export const DEFAULT_QUERY_RETRY_COUNT: number = 2;
